

import * as React from 'react'
const { useReducer,createContext } = React;
const EVENT = {
  // 点击证书
  certification: 'CLICK_CERTIFICATION',
  // 点击sku
  sku: 'CLICK_SKU'
}

const initialState: any = {};
const store = createContext( initialState );
const { Provider } = store;

const StoreProvider = ( { children }: JSX.ElementChildrenAttribute ): JSX.Element => {
  const [state,dispatch] = useReducer( ( state: any,action: any ) => {
    return action;
  },initialState );

  return <Provider value={{ state,dispatch }}>{children}</Provider>;
};

export { store,StoreProvider,EVENT };
